import React from 'react';
import PropTypes from 'prop-types';

import {KeyCode} from '~/src/utilities/constants/keyboard';
import {getKeyCodeFromEvent} from '~/src/utilities/helpers/keyboard';

class KeyboardListener extends React.Component {
    onKeyUp = (event) => {
        const keyCode = getKeyCodeFromEvent(event);

        switch (keyCode) {
            case KeyCode.ESC:
                this.props.onEsc && this.props.onEsc(keyCode);
                break;
            case KeyCode.LEFT:
                this.props.onLeft && this.props.onLeft(keyCode);
                break;
            case KeyCode.RIGHT:
                this.props.onRight && this.props.onRight(keyCode);
                break;
            default:
                break;
        }
    };

    addEvents() {
        document.addEventListener('keyup', this.onKeyUp);
    }

    removeEvents() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    componentDidMount() {
        this.addEvents();
    }

    componentWillUnmount() {
        this.removeEvents();
    }

    render() {
        return null;
    }
}

if (process.env.NODE_ENV === 'development') {
    KeyboardListener.propTypes = {
        onEsc: PropTypes.func,
        onLeft: PropTypes.func,
        onRight: PropTypes.func
    };
}

export default KeyboardListener;
